module.exports = __webpack_public_path__ + "img/contact_2.21d806ce.jpg";